module.exports = __webpack_public_path__ + "img/am_active.d2883669.svg";